"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "5", cy: "12", r: "2", fill: "currentColor" }),
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "2", fill: "currentColor" }),
    react_1.default.createElement("circle", { cx: "19", cy: "12", r: "2", fill: "currentColor" })));
